import { useEffect } from "react";
import { useMailAuthReady } from "@/hooks/useMailAuthReady";
import {
  installMailPushFocusGuard,
  syncMailWebPushOnBoot,
} from "@/lib/mail/mailWebPushRuntime";

/** Après SSO : resubscribe + silence OS si Mail a le focus. */
export function MailWebPushBoot() {
  const { state } = useMailAuthReady();

  useEffect(() => {
    if (state !== "ready") return;
    void syncMailWebPushOnBoot();
  }, [state]);

  useEffect(() => installMailPushFocusGuard(), []);

  return null;
}
